import React, { useCallback } from "react";
// arco
import { Avatar, Dropdown, Menu, Button, Typography, Divider } from '@arco-design/web-react';
import { useAuthContext } from "src/auth/hooks";
import usePopover from "src/hooks/use-popover";
import { getAvatarName } from "src/utils/format-name";

// ----------------------------------------------------------------------

export default function AccountPopover() {
    const { user, logout, kicked } = useAuthContext();
    const avatarFallbackText = getAvatarName(user?.name);

    const popover = usePopover();

    const handleLogout = useCallback(() => logout().then(() => popover.onClose()).catch((e) => {
        const { code } = e || {};

        if (code === "auth.jwt.invalid") {
            kicked();
        } else {
            console.error(e);
        }
    }), [logout, popover, kicked]);

    const menu =
        <Menu>
            <Menu.Item key="user" style={{ padding: "0px 16px 0 16px", pointerEvents: "none" }}>
                <Typography.Text bold>{user?.name || '-'}</Typography.Text>
            </Menu.Item>
            <Menu.Item key="email" style={{ padding: "0px 16px 12px 16px", pointerEvents: "none" }}>
                <Typography.Text type="secondary" style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '300px' }}>{user?.email ?? '-'}</Typography.Text>
            </Menu.Item>

            <Divider style={{ margin: '4px 0', borderBottomStyle: 'dashed' }} />

            <Menu.Item key="logout" style={{ height: 40, lineHeight: '40px', color: '#F8362B' }} onClick={handleLogout}>
                退出登录
            </Menu.Item>
        </Menu>


    return (
        <Dropdown
            trigger="click"
            droplist={menu}
            position="bl"
        >
            <Button
                style={{ padding: 0, minWidth: 36, height: 36, margin: '0 6px', background: 'transparent', border: 'none' }}
            >
                <Avatar size={32} style={{ backgroundColor: '#E8F3FF', color: '#0067D7' }}>
                    {avatarFallbackText}
                </Avatar>
            </Button>
        </Dropdown>
    );
}
